import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Link, useLocation} from 'react-router-dom';
import LoginCredentials from '../../../common/component/form/LoginCredentials';
import accountApi from '../../api/accountApi';
import '../../style/PasswordReset.less';

function PasswordReset() {
    const [t] = useTranslation();
    const {search} = useLocation();
    const [success, setSuccess] = useState(false);

    const query = new URLSearchParams(search);
    const token = query.get('token');
    const email = query.get('email');
    const [infoText, setInfoText] = useState('PasswordReset.INFO_RESET');

    const [password, setPassword] = useState({
        password: null,
        passwordRepeat: null
    });
    const [isValidated, setIsValidated] = useState(false);
    const [validation, setValidation] = useState({
        password: true,
        passwordRepeat: true
    });
    const [isTokenValid, setIsTokenValid] = useState(false);

    useEffect(() => {
        if (email && token) {
            accountApi.checkTokenValidity(email, token).then((res) => {
                if (res.data.success) {
                    setIsTokenValid(true);
                } else {
                    setIsTokenValid(false);
                }
            }).catch(() => {
                setIsTokenValid(false);
            });
        }
    }, [email, token]);

    useEffect(() => {
        if (isValidated) {
            validate();
        }
    }, [password]);

    function handlePasswordChange(field, value) {
        setPassword({
            ...password,
            [field]: value
        });
    }

    function savePassword() {
        if (validate()) {
            accountApi.passwordReset(token, email, password.password).then((res) => {
                if (res.data.success) {
                    setSuccess(true);
                    setInfoText('PasswordReset.RESET_SUCCESS');
                } else {
                    setSuccess(false);
                }
            }).catch(() => {
                setSuccess(false);
            });
        }
    }

    function validate() {
        const newValidation = {
            password: !!password.password,
            passwordRepeat: !!password.passwordRepeat && password.password === password.passwordRepeat
        };
        setIsValidated(true);
        setValidation(newValidation);

        // Check if password is valid
        return Object.values(newValidation).every(field => !!field);
    }

    return (
        <>
            <div className="login-wrapper">
                <div className="mr-4 ml-4">
                    <div className="card">
                        <div className="card-body big-label">
                            <h1>{t('PasswordReset.RESET')}</h1>
                            {
                                isTokenValid ?
                                    <>
                                        <p id="password-reset-text" className="text-center mx-auto">{t(infoText)}</p>
                                        {
                                            success ?
                                                <div className="text-center">
                                                    <Link to="/login" className="btn btn-primary">{t('Confirmation.GO_TO_LOGIN')}</Link>
                                                </div>
                                                :
                                                <div className="mt-5">
                                                    <LoginCredentials
                                                        account={password}
                                                        onChange={handlePasswordChange}
                                                        validation={validation}
                                                        passwordReset={true}/>

                                                    <div className="button-footer mb-4">
                                                        <button className="btn btn-primary" onClick={savePassword}>{t('PasswordReset.RESET_BUTTON')}</button>
                                                    </div>
                                                </div>
                                        }
                                    </>
                                    :
                                    <>
                                        <p className="text-center mx-auto" style={{maxWidth: '500px'}}>{t('Error.WRONG_TOKEN')}</p>
                                    </>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default PasswordReset;
